import React from "react";
import autoBind from 'react-autobind';
import { Layout, Form, Row, Col, Select, Button, Tag, Checkbox, Divider } from 'antd';
import PageHeader from '@/components/PageHeader/PageHeader';
import DatePicker from '@/components/DatePicker/DatePicker';
import { PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import { GrDocumentPdf, GrDocumentExcel } from "react-icons/gr";
//
import CustomComponent from '@/components/CustomComponent';
import WhiteBox from '@/views/commonComponents/WhiteBox';
import CommonLoadingView from '@/views/commonComponents/CommonLoadingView';
import config from "@/config/config";
import CommonEmployerSelectionModal from "@/views/commonComponents/CommonEmployerSelectionModal";
import Utils from "@/components/Utils";
import Globals from "@/config/Globals";
//
export default class AdminMembersListReportView extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);

    const { sectors, memberClassifications, unitsNumbers, memberStatuses } = this.props.app.sharedCache().getConfig();

    this.state = {
      isLoading: false,
      classifications: memberClassifications || [],
      sectors: sectors || [],
      units: unitsNumbers || [],
      memberStatuses: memberStatuses || [],
      selectedEmployers: [],
      allSectors: false,
      allUnits: false,
      filterBy: null,
    };
  }

  componentDidMount() {
    document.title = `${config.ApplicationName} - Members List`;
  }

  handleSearchEmployer() {
    this.employerSelectionModal.show();
  }

  handleSelectEmployer(employer) {
    this.setState((prevState) => ({
      ...prevState,
      selectedEmployers: [...prevState.selectedEmployers, employer],
    }));
  }

  handleDeselectEmployer(removedEmployer) {
    this.setState((prevState) => ({
      ...prevState,
      selectedEmployers: prevState.selectedEmployers.filter((employer) => employer.id !== removedEmployer.id),
    }));
  }
  
  async handleSubmit() {
    const formData = await this.form.validateFields();

    if (formData) {
      delete formData.filterBy;

      formData.missingPostalCode = !!formData.missingPostalCode;

      formData.allowRegisterDateIsNull = !!formData.allowRegisterDateIsNull;
      
      formData.employerID = this.state.selectedEmployers.map((employer) => employer.id);
      formData.employerID = formData.employerID.length < 1 ? null : formData.employerID;

      formData.sectorID = formData.sectorID?.length < 1 ? null : formData.sectorID;
      formData.unitNumberID = formData.unitNumberID?.length < 1 ? null : formData.unitNumberID;

      formData.duesPaidThru = formData.duesPaidThru ? moment(formData.duesPaidThru).format(Globals.DefaultSimpleDateFormat) : null;
      formData.initiationDate = formData.initiationDate ? moment(formData.initiationDate).format(Globals.DefaultSimpleDateFormat) : null;
      const contentType = formData.fileFormat;
      delete formData.fileFormat;

      this._generate(formData, contentType);
    }
  }

  handleChangeAllSectors({ target: { checked } }) {
    if (checked) {
      this.setState({ allSectors: true });
      this.form.setFieldsValue({
        sectorID: [],
      });
    } else {
      this.setState({ allSectors: false });
    }
  }

  handleChangeAllUnits({ target: { checked } }) {
    if (checked) {
      this.setState({ allUnits: true });
      this.form.setFieldsValue({
        unitNumberID: [],
      });
    } else {
      this.setState({ allUnits: false });
    }
  }

  handleChangeFilterBy(value) {
    this.setState({ filterBy: value });
  }

  render() {
    return (
      <Layout.Content className="pageContent">
        <CommonEmployerSelectionModal
          app={this.props.app}
          onSelect={this.handleSelectEmployer}
          disable={this.state.selectedEmployers.map((employer) => employer.id)}
          {...Utils.propagateRef(this, 'employerSelectionModal')}
        />

        <CommonLoadingView isLoading={this.state.isLoading} isFixed />
        <PageHeader title="Members List" extra={[<Button key="1" onClick={this.handleSubmit} type='primary'>Generate List</Button>]} />
        <Layout.Content>
          <WhiteBox>
            <Form layout="vertical" {...Utils.propagateRef(this, 'form')}>
              <Row>
                <Col span={24}>
                  <Form.Item name="filterBy" label="Group by" rules={[{ required: true, message: 'This field is required.' }]}>
                    <Select placeholder="Select..." onChange={this.handleChangeFilterBy}>
                      {this.props.app.acl.hasPermission(Globals.Components.REPORT_MEMBERS_BY_CLASSIFICATION, Globals.AllLevels) && (
                        <Select.Option value="membersByClassification">Classification</Select.Option>
                      )}
                      {this.props.app.acl.hasPermission(Globals.Components.REPORT_MEMBERS_BY_EMPLOYER, Globals.AllLevels) && (
                        <Select.Option value="membersByEmployer">Employer</Select.Option>
                      )}
                      {this.props.app.acl.hasPermission(Globals.Components.REPORT_MEMBERS_BY_SECTOR, Globals.AllLevels) && (
                        <Select.Option value="membersBySector">Sector</Select.Option>
                      )}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Divider />
              <Row>
                <Col>
                  <Form.Item label="Employers">
                    {this.state.selectedEmployers.length > 0 && (
                      this.state.selectedEmployers.map((employer) => (
                        <Tag
                          key={employer.id} closable
                          onClose={this.handleDeselectEmployer.bind(this, employer)}
                        >
                          {employer.name}
                        </Tag>
                      ))
                    )}
                    <Tag className="site-tag-plus" onClick={this.handleSearchEmployer}>
                      <PlusOutlined /> Select Employer
                    </Tag>
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={4}>
                  <Form.Item name="fileFormat" label="File Format" rules={[{ required: true, message: 'This field is required.' }]}>
                    <Select placeholder="Select...">
                      <Select.Option value="application/pdf"><GrDocumentPdf style={{ marginRight: '10px' }} />PDF</Select.Option>
                      <Select.Option value="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"><GrDocumentExcel style={{ marginRight: '10px' }} />Excel</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={5} offset={1} style={{ display: 'flex' }}>
                  <Form.Item name="duesPaidThruOperator" label="Dues Paid Thru" initialValue="=">
                    <Select placeholder="Select..." style={{ width: 60 }}>
                      <Select.Option value=">">{`>`}</Select.Option>
                      <Select.Option value=">=">{`>=`}</Select.Option>
                      <Select.Option value="=">{`=`}</Select.Option>
                      <Select.Option value="<">{`<`}</Select.Option>
                      <Select.Option value="<=">{`<=`}</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item name="duesPaidThru" label=" " style={{ marginLeft: -30 }}>
                    <DatePicker format={Globals.DefaultSimpleDateFormat} style={{ flex: 1, minWidth: 200 }} />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item name="initiationDate" label="Initiation Date">
                    <DatePicker format={Globals.DefaultSimpleDateFormat} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={7} offset={1}>
                  <Form.Item name="memberTypes" label="Member Types">
                    <Select placeholder="Select..." mode="multiple">
                      {Object.keys(Globals.MemberStatuses).map((key) => (
                        <Select.Option key={key} value={key}>{Globals.MemberStatuses[key]}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={8}>
                  <Form.Item name="sectorID" label="Sectors">
                    <Select placeholder="Select..." mode="multiple" disabled={this.state.allSectors}>
                      {this.state.sectors.map((sector) => (
                        <Select.Option key={sector.id} value={sector.id}>{sector.name}</Select.Option>
                      ))}
                      <Select.Option key={0} value={0}>{'None'}</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col style={{ marginLeft: 10 }}>
                  <Form.Item label=" ">
                    <Checkbox onChange={this.handleChangeAllSectors}>All sectors</Checkbox>
                  </Form.Item>
                </Col>
                <Col span={8} offset={1}>
                  <Form.Item name="unitNumberID" label="Units">
                    <Select placeholder="Select..." mode="multiple" disabled={this.state.allUnits}>
                      {this.state.units.map((unit) => (
                        <Select.Option key={unit.id} value={unit.id}>{unit.number} - {unit.description}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col style={{ marginLeft: 10 }}>
                  <Form.Item label=" ">
                    <Checkbox onChange={this.handleChangeAllUnits}>All units</Checkbox>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={5}>
                  <Form.Item name="classificationID" label="Classification">
                    <Select placeholder="Select..." mode="multiple">
                      {this.state.classifications.map((code) => (
                        <Select.Option key={code.id} value={code.id}>{code.name}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4} offset={1}>
                  <Form.Item name="status" label="Member Status">
                    <Select placeholder="Select...">
                      {Object.keys(Globals.MemberSearch_Status).map((item) => (
                        <Select.Option
                          key={Globals.MemberSearch_Status[item].key}
                          value={Globals.MemberSearch_Status[item].key}
                        >
                          {Globals.MemberSearch_Status[item].name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={5} offset={1}>
                  <Form.Item name="statusID" label="Activity Code">
                    <Select placeholder="Select..." mode="multiple">
                      {this.state.memberStatuses.map((code) => (
                        <Select.Option key={code.id} value={code.id}>{code.statusCode} - {code.description}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col offset={1}>
                  <Form.Item label="Missing postal code" name="missingPostalCode" valuePropName="checked">
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col offset={1}>
                  <Form.Item label="Only members with register date" name="allowRegisterDateIsNull" valuePropName="checked" initialValue={false}>
                    <Checkbox />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </WhiteBox>
        </Layout.Content>
      </Layout.Content>
    )
  }

  /* private API */
  async _generate(data, contentType) {
    const { filterBy } = this.state;

    this.startLoading();
    //request
    const fallback = { [filterBy]: () => {} }; // this is here to prevent unhandled errors
    const apiParent = this.props.app.api.reports[filterBy] ? this.props.app.api.reports : fallback;
    const resp = await apiParent[filterBy](data, contentType);
    if (!this._isMounted) return;
    if (resp.statusCode == 200 && resp.body) {
      Utils.downloadBlob(resp.body, `${filterBy}-${moment(new Date()).format(Globals.DefaultSimpleDateFormat)}`, contentType === 'application/pdf' ? 'pdf' : 'xlsx');
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resp);
    }
    this.setState({ isLoading: false });
  }
}
